import { Link } from "react-router-dom";

const Table = ({ id, details, open = false, toggle }) => {
	return (
		<table className="approved assigned">
			<thead>
				<tr>
					<th colSpan="3" className="hdg">
						{details.title}
					</th>
				</tr>
			</thead>
			<thead className={open ? "" : "hidden"}>
				<tr>
					<td className="spot">Spot</td>
					<td className="left">Guest Name</td>
					<td className="status">Status</td>
				</tr>
			</thead>
			<tbody className={open ? "" : "hidden"}>
				{details.data.map((item, index) => {
					return item.name ? (
						<tr
							key={index}
							className={
								(id === "golf" || id === "sporting") && item.spot % 4 === 0
									? "bottom"
									: ""
							}
						>
							<td>{item.spot}</td>
							<td className="left">
								{item.name === "donated" ? (
									<span className="working">Donated Back</span>
								) : item.status === 1 ? (
									<span>
										<Link to={`/dashboard/guest/${item.id}`}>{item.name}</Link>
									</span>
								) : item.status === 2 ? (
									<span className="working">
										Waiting on response from{" "}
										<Link
											to={`/dashboard/guest/${item.id}`}
											className="working"
										>
											{item.name}
										</Link>
									</span>
								) : item.status === 4 ? (
									<span className="notice">
										Invite queued for{" "}
										<Link to={`/dashboard/guest/${item.id}`} className="notice">
											{item.name}
										</Link>
									</span>
								) : (
									""
								)}
							</td>
							<td className="center">
								{item.status === 1 ? (
									<i className="fa fa-check-circle fa-lg success" />
								) : item.status === 2 ? (
									<i className="fa fa-hourglass-o fa-lg working" />
								) : item.status === 4 ? (
									<i className="fa fa-clock-o fa-lg notice" />
								) : (
									""
								)}
							</td>
						</tr>
					) : (
						<tr
							key={index}
							className={
								(id === "golf" || id === "sporting") && item.spot % 4 === 0
									? "bottom"
									: ""
							}
						>
							<td className={item.status === 5 ? "working" : ""}>
								{item.spot}
							</td>
							<td>
								{item.status === 5 ? (
									<span className="working">
										<i>not used</i>
									</span>
								) : (
									<span className="working">-- empty --</span>
								)}
							</td>
							<td className="center working">{item.status === 5 ? "-" : ""}</td>
						</tr>
					);
				})}
			</tbody>
			<tbody>
				<tr>
					<td colSpan="3" className="center plus-minus">
						<button type="button" className="naked" onClick={() => toggle(id)}>
							<div>
								<i
									className={
										open
											? "fa fa-minus-square-o fa-lg"
											: "fa fa-plus-square-o fa-lg"
									}
								/>
								<span>{open ? `Hide Details` : `Show Details`}</span>
							</div>
						</button>
					</td>
				</tr>
			</tbody>
		</table>
	);
};

export default Table;
